<template>
  <section class="sub_contents_wrap container">
    <div class="management_top_box">
      <h4>{{ $t("management.noticeManagement") }}</h4>
    </div>
    <div class="brick_box">
      <div class="view_top">
        <div class="view_title">{{ notice.title }}</div>
        <ul class="view_info">
          <li class="view_user">{{ notice.userName }}</li>
          <li class="view_date">{{ notice.firstRegDatetime }}</li>
        </ul>
        <div class="view_file" v-if="files.length > 0 && files != null">
          <ul>
            <li>
              <span>File</span>
              <a
                v-for="(file, index) in files"
                :key="index"
                href="#"
                @click="downloadFile(file)"
              >
                {{ file.fileNm }}
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div v-if="notice.content" v-html="notice.content" class="view_t"></div>
      <div class="list_bottom_bt">
        <router-link
          to="/management/support/notice"
          class="btn btn-outline-dark btn-lg m-1"
          >{{ $t("common.list") }}</router-link
        >
        <button
          type="button"
          @click="deleteNotice()"
          class="btn btn-secondary btn-lg m-1"
        >
          {{ $t("common.delete") }}
        </button>
        <router-link
          :to="{ name: 'mgmtNoticeForm', params: { boardId: notice.boardId } }"
          @click.native="goNoticeForm(notice.boardId)"
          class="btn btn-primary btn-lg m-1"
          >{{ $t("common.edit") }}</router-link
        >
      </div>
    </div>
  </section>
</template>

<script>
import { goDownloadFile } from "@/api/file";
import { getNoticeMgmtDetail, deleteNotice } from "@/api/notice";

export default {
  data() {
    return {
      id: "",
      boardId: "",
      notice: {
        boardId: "",
        title: "",
        content: "",
        attributeName: "",
        firstRegDatetime: "",
        fileList: [],
      },
      files: [],
      isTrue: false,
      componentName: null,
      confirmYn: false,
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      try {
        this.notice.boardId = this.$route.query.boardId;
        const response = await getNoticeMgmtDetail(this.notice.boardId);
        this.notice = response.data.notice;
        this.files = response.data.files;
      } catch (err) {
        console.log(err);
      }
    },
    async deleteNotice() {
      this.confirmYn = confirm(this.$t("alert.delete"));
      if (this.confirmYn) {
        try {
          this.notice.fileList = this.files;
          const { data } = await deleteNotice(this.notice);
          if (data.status) {
            alert(this.$t("alert.deletedSuccessfully"));
            this.$router.push({ name: "mgmtNotice" });
          } else {
            alert(this.$t("alert.ErrorPlzcontactManager"));
          }
        } catch (err) {
          console.log(err);
        }
      } else {
        return;
      }
    },
    async downloadFile(file) {
      try {
        const res = await goDownloadFile(file.fileId);
        let data = res.data;
        if (!data) {
          return;
        }
        const blob = new Blob([data]);
        if (window.navigator.msSaveOrOpenBlob) {
          // compatible IE10
          navigator.msSaveBlob(blob, file.fileId);
        } else {
          // IE core support other non-H5 browsers
          let url = window.URL.createObjectURL(blob);
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", file.fileNm);
          document.body.appendChild(link);
          link.click();
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 수정폼으로 이동
    goNoticeForm(boardId) {
      this.$store.commit("setFlag", "U");
      this.$store.commit("setBoardId", boardId);
    },
  },
};
</script>

<style></style>
